<style scope lang="scss">
    .exp_progress {
        color: #000;
        height: auto;

        .progress {
            width: 100%;
            height: auto;
            border-top: 1px solid #000;
            border-left: 1px solid #000;
            box-sizing: border-box;

            .code {
                float: left;
                width: 98px;
                height: 98px;
                margin-right: 12px;

                img {
                    margin: 0 0 0 2px;
                    width: 100%;
                    height: 100%;
                }
            }

            .info {
                margin-top: 10px;
                float: left;
                width: 280px;
                color: #000;

                dt {
                    font-size: 22px;
                }

                dd {
                    color: #999;
                    line-height: 1.6;
                }
            }

            .logo {
                float: right;
                width: 250px;
                height: 130px;
            }

            .waybill {
                height: 80px;
                line-height: 80px;
                text-align: center;
                font-size: 30px;
                font-weight: bold;
                color: #000;
                letter-spacing: 8px;
            }

            td {
                border-bottom: 1px solid #000;
                border-right: 1px solid #000;
                font-size: 12px;

                .content {
                    font-size: 18px;
                    color: #000;
                }

                .address {
                    line-height: 1.8;
                }

                .product {
                    color: #000;
                    line-height: 1.6;
                    padding: 6px 0;
                    font-size: 13px;

                    span {
                        display: inline-block;
                        margin: 0 8px 0 0;
                    }
                }

                .case {
                    padding-top: 5px;
                    font-size: 30px;
                    color: #000;
                    text-align: center;
                }
            }

            td.padding {
                padding: 6px;
            }
        }

        .el-dialog__header {
            padding: 0;
        }

        .el-dialog__body {
            padding: 5px;
        }

        .images {
            height: 136px;
            border-bottom: 1px solid #000;
        }
    }

    .exp_images {
        text-align: center;

        img {
            max-width: 100%;
        }
    }

    .clearb {
        clear: both;
    }

    .exp_mprogress {
        position: relative;
        width: 96%;
        margin: 0 auto;
        border: 1px solid #333;

        .exp_number {
            height: 2.2rem;
            line-height: 2.2rem;
            padding-left: 0.6rem;
        }

        .showImages {
            position: absolute;
            right: 0.3rem;
            top: 0.3rem;
        }

        .info {
            border-top: 1px dotted #333;
            text-align: center;
            margin: 0.3rem auto;
            padding-top: 0.5rem;

            dt, dd {
                margin: 0;
                padding: 0.1rem 0;
            }

            img {
                width: 8rem;
                height: 8rem;
            }
        }

        .exp_main {
            width: 92%;
            margin: 0;
            padding: 0 4%;
            font-size: 0.8rem;

            dt, dd {
                margin: 0;
                padding: 0.15rem 0;
                display: inline-block;
            }

            dt {
                float: left;
            }

            dd {
                float: right;
                color: #999;
                text-align: right;
                max-width: 75%;
            }
        }
    }
    .exp_mprogress_button {
        margin:6px auto 0 auto; 
        width: 96%;
        .van-button {
            width: 100%;
        }
    }
</style>
<template>
    <div>
        <div class="exp_mprogress">
            <div class="exp_number">寄件时间：{{ expItems.auCreationTime }}</div>
            <van-button type="primary" size="mini" class="showImages"
                        @click="showExpImages()" v-if="expItems.status > 3">查看包裹图片
            </van-button>
            <dl class="exp_main">
                <dt>单号</dt>
                <dd>{{expItems.expressNo}}</dd>
            </dl>
            <div class="clearb"></div>
            <dl class="exp_main">
                <dt>收件人</dt>
                <dd>{{ expItems.addressee && expItems.addressee.name }}</dd>
            </dl>
            <div class="clearb"></div>
            <dl class="exp_main">
                <dt>电话</dt>
                <dd>{{expItems.addressee && expItems.addressee.tel}}</dd>
            </dl>
            <div class="clearb"></div>
            <dl class="exp_main">
                <dt>收货人地址</dt>
                <dd>{{expItems.fullAddress}}</dd>
            </dl>
            <div class="clearb"></div>
            <dl class="exp_main">
                <dt>寄件人</dt>
                <dd>{{expItems.consignor && expItems.consignor.name}}</dd>
            </dl>
            <div class="clearb"></div>
            <dl class="exp_main">
                <dt>电话</dt>
                <dd>{{expItems.consignor && expItems.consignor.tel}}</dd>
            </dl>
            <div class="clearb"></div>
            <div style="display: flex; flex-direction: row; border-top: 1px solid #000; padding-top: 15px;">
                <div class="goodsItems" style="flex: 1; padding-left: 10px;">
                    <div v-for="item in expItems.items" :key="item.productId">{{item.productName}} x{{item.quantity}}</div>
                </div>
                <div style="width: 140px;">
                    <div style="padding: 0 10px; font-weight: bold">{{expItems.expressTypeDesc}}</div>
                    <div v-if="expItems.codeSrc"><img :src="expItems.codeSrc" style="max-width: 100%" /></div>
                    <div style="padding: 0 10px">长按识别二维码查询进度</div>
                </div>
            </div>
        </div>
        <div class="exp_mprogress_button">
            <van-button type="danger" @click="showExpTail()">上传/修改身份证</van-button>
        </div>
        <van-popup get-container="body" v-model="isShowExpTail" class="Show" position="bottom" style="width: 100%;">
            <van-nav-bar
                title="上传/修改身份证"
                left-text="" />
            <div class="cmain">
                <tail :expId="expItems.id" v-if="isShowExpTail" v-on:closeTail="closeTail"></tail>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import areaData from '@/js/area.js'
    import Vue from 'vue';
    import {ImagePreview} from 'vant';
    import tail from '@/views/m/pages/Expresses/tail.vue'

    Vue.use(ImagePreview);
    export default {
        name: 'expProgress',
        props: {
            'expProgressId': {
                default: 0,
                type: Number
            }
        },
        components: {
            tail
        },
        data() {
            return {
                expItems: {},
                expId: 0,
                isShowExpImages: false,
                isShowExpTail: false
            }
        },
        watch: {
            expProgressId(val) {
                this.getExpDetail();
            }
        },
        async mounted() {
            await areaData.getAreasData()
            this.getExpDetail();
        },
        methods: {
            getExpDetail() {
                this.$axios.get(window.consts.apis.getParcelById + "?Id=" + this.expProgressId).then(res => {
                    if (res.success) {
                        let item = res.result;
                        console.log('item:', item)
                        this.expItems = item;
                        this.expItems.fullAddress = areaData.getAreaNames([item.addressee.province, item.addressee.city, item.addressee.area]).join(" ") + " " + item.addressee.detail;
                        //this.getExpQRCode();
                        this.expItems.codeSrc = window.baseUrl + window.consts.apis.getExpQRCode + "?ver=" + Math.random() + "&parcelId=" + this.expProgressId
                    } else {
                        this.$toast.fail(res.error.message);
                        return false;
                    }
                }).catch(e => {
                    this.$toast.fail("获取邮单失败!");
                    return false;
                });
            },
            getExpQRCode() {
                this.$axios.get(window.consts.apis.getExpQRCode + "?parcelId=" + this.expProgressId).then(res => {
                    if (res.success) {

                    } else {
                        this.$toast.fail(res.error.message);
                        return false;
                    }
                }).catch(e => {
                    this.$toast.fail("获取二维码失败，请刷新页面后再试!");
                    return false;
                });
            },
            showExpImages() {
                if (this.expItems.images && this.expItems.images.length > 0) {
                    ImagePreview(this.expItems.images)
                } else {
                    this.$toast.fail("暂无打包图片~");
                }
            },
            showExpTail() {
                this.isShowExpTail = true
            },
            closeTail() {
                this.isShowExpTail = false
            }
        }
    }
</script>
